"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const Badge = ({
  className,
  color,
  children
}) => {
  const classes = (0, _classnames.default)('Badge', `Badge-${color}`, className);
  return /*#__PURE__*/_react.default.createElement("span", {
    className: classes
  }, children);
};
Badge.defaultProps = {
  color: 'default'
};
var _default = exports.default = Badge;